<template>
    <div class="page">
        <van-nav-bar :title="$t('xqaltit')" class="nav-bar newnavbar">
            <template #left>
                <van-icon name="arrow-left" color="#fff" @click="back()" />
            </template>
        </van-nav-bar>
        <div class="caseDetail">
            <div class="caseTit">
                <van-icon name="label" color="#eb6e96" size="26" />
                <span>{{ caseData.title }}</span>
            </div>
            <div class="caseMain">
                <div :class="{ active: caseData.gender == 1 }">
                    {{ caseData.age }} / {{ caseData.gender == 1 ? $t('male') : $t('female') }}
                </div>
                <div :class="{ active2: caseData.gender == 1 }">{{ caseData.zhiye }}</div>
                <div>
                    <span>{{ $t('LastUpdated') }}:</span>
                    <span v-if="caseData.create_time">{{ new Date(caseData.create_time *
                        1000).toLocaleDateString().replace(/\//g, "/") }}</span>
                </div>
            </div>
            <div class="caseAddress">
                <van-icon name="location" color="#666" size="18" />
                <span>{{ caseData.address }}</span>
            </div>
            <van-divider />
            <div>
                <van-image :src="caseData.imgUrl" :height="200" width="100%" fit="cover">
                    <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                    </template>
                    <template v-slot:error><van-image src="/img/error.png" /></template>
                </van-image>
            </div>
            <div v-html="caseData.htmlContent"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            caseData: {},
        };
    },
    created() {
        this.$http({
            method: 'get',
            url: 'getCasedata',
            data: { id: this.$route.query.id }
        }).then(res => {
            console.log("getCasedata", res.data);
            this.caseData = res.data || {};
            this.caseData.imgUrl = this.$config.baseURL + this.caseData.imgurl;
            this.caseData.htmlContent = this.formatRichText(this.caseData.content);
        });
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        formatRichText(html) {
            return html.replace(/<img/g, '<img style="max-width: 100%; min-width: 100%;"');
        },
    },
};
</script>

<style lang="less" scoped>
.newnavbar {
    height: 100px;
    background: #1989fa !important;
}

.caseDetail {
    background: #fff;
    padding: 15px;
    height: calc(100vh - 100px);
    overflow: auto;

    .caseTit {
        display: flex;
        align-items: center;
        font-size: 20px;

        >span {
            margin-left: 10px;
            font-weight: bold;
        }
    }

    .caseMain {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 20px;

        >div:nth-child(1) {
            color: #fff;
            background: #d96c62;
            border-radius: 30px;
            padding: 2px 10px;
            font-weight: bold;
        }

        >div:nth-child(2) {
            margin: 0 15px 0 10px;
            color: #d96c62;
            font-weight: bold;
        }

        >div:nth-child(3) {
            color: #949494;
        }

        >div.active {
            background: #6696d9;
        }

        >div.active2 {
            color: #6696d9;
        }
    }

    .caseAddress {
        margin-top: 20px;
        font-size: 14px;
        display: flex;
        align-items: center;
        color: #666;

        >span {
            margin-left: 5px;
        }
    }
}
</style>
